import { createFileRoute } from "@tanstack/react-router";
import AdminDemoSetsPage from "@/pages/admin/demos/sets";
import { useDemosPermissions } from "@/pages/admin/demos";

export const Route = createFileRoute("/app/admin/demos/sets/")({
  component: RouteComponent,
});

function RouteComponent() {
  const {
    userCanViewAllPrograms,
    userCanViewAllSets,
    userCanViewAllSetDemos,
  } = useDemosPermissions();

  return (
    <AdminDemoSetsPage
      userCanViewAllPrograms={userCanViewAllPrograms}
      userCanViewAllSets={userCanViewAllSets}
      userCanViewAllSetDemos={userCanViewAllSetDemos}
    />
  );
}
